<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-task" data-toggle="modal" data-target="#exampleModal">Add</button> -->
  
            <div class="personal-details">
                <div class="row">
                  <div class="col-md-9 col-lg-9">
                    <div class="map-container">
                      <div class="map-frame">
                        <div id="map">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3" style="padding-left: 0;">
                    <input type="text" placeholder="search" [(ngModel)]="search" class="form-control">
                    <div class="customerList">
                      <!-- <p (click)="onChoseLocation()" >All</p> -->
                      <p *ngFor="let list of branchList | filter:search;let i = index ">{{list.name}}</p>
                    </div>
                  </div>
           
                </div>

                <div class="branch-add-block" *ngIf="isShowAddBranch">
                  <div class="add-form row">
                    <div class="col-lg-6 col-md-6" [formGroup]="form">
                      <div>
                        <h5>Add Branch</h5>
                      </div>
                      <div class="form-group">
                        <label>Branch Name</label>
                        <input formControlName="name" type="text" class="form-control">
                      </div>
                      <div class="form-group">
                        <label>Branch Description</label>
                        <input formControlName="description" type="text" class="form-control">
                      </div> 
                      <div class="form-group">
                        <label>Branch Address</label>
                        <input formControlName="address" type="text" class="form-control">
                      </div> 
                      <!-- <div class="form-group">
                        <label>Branch Latitude</label>
                        <input formControlName="latitude" type="text" class="form-control">
                      </div> 
                      <div class="form-group">
                        <label>Branch Longitude</label>
                        <input formControlName="longitude" type="text" class="form-control">
                      </div>  -->
                      <div class="modal-footer">
                        <button type="button" id="closeModalButton" class="btn btn-secondary" (click)="remove()">Cancel</button>
                        <button type="button" (click)="addBranch()" class="btn btn-primary">Add Branch</button>
                      </div>
                    </div>
                  </div>

                </div>
            </div>
  
        </div>
    </div>
  </div>



  <button style="display: none;" id="add-branch-popup" data-toggle="modal" data-target="#exampleModal">Add Branch</button>

  <div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Add Branch
            <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </span>
          </h5>
        </div>
        <div class="modal-body">
    
          <div [formGroup]="form">
    
              <div class="form-group">
                  <label>Branch Name</label>
                  <input formControlName="name" type="text" class="form-control">
              </div>
              <div class="form-group">
                  <label>Branch Description</label>
                  <input formControlName="description" type="text" class="form-control">
              </div> 
              <div class="form-group">
                <label>Branch Address</label>
                <input formControlName="address" type="text" class="form-control">
              </div> 
              <!-- <div class="form-group">
                <label>Branch Latitude</label>
                <input formControlName="latitude" type="text" class="form-control">
              </div> 
              <div class="form-group">
                <label>Branch Longitude</label>
                <input formControlName="longitude" type="text" class="form-control">
              </div>   -->
              <!-- <div class="form-group">
                  <label>Branch Version</label>
                  <input formControlName="version" type="text" class="form-control">
              </div> -->
    
              <!-- <div class="form-group">
                  <label>Active status</label>
                  <input  type="checkbox" formControlName="isActive" class="form-control">
              </div> -->
    
          </div>
    
     
        <div class="modal-footer">
          <button type="button" id="closeModalButton" (click)="remove()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="addBranch()" class="btn btn-primary">Add Branch</button>
        </div>
      </div>
    </div>
    </div>
  </div>